export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7i-a9e8eb8361bed477cf2b7ce115fe4a86.webp";